// The user role tokens as they appear on a wire subject. Member names and
// values mirror rentouch_shared.role.Role, which the Python stubs reference
// directly; the generator's tests pin the two together. `backend` is not a
// user role and lives in subjectVars.ts as BACKEND_ROLE.
export const WireRole = {
  ADMIN: "admin",
  PLANNING_INTERVAL_ADMIN: "planning_interval_admin",
  USER: "user",
  OBSERVER: "observer",
} as const;

export type WireRole = (typeof WireRole)[keyof typeof WireRole];
